export default {
  PusherKey: '946bd696994b61fce258',
  ISC_API_KEY: 'CMKStF9fJpq8judYTn',
  GTM: 'GTM-TV892P7',
  Segment: 'zNwfm1Npxl7Q6p2ErOswkEzg6QJbOdyq',
  CustomerIOSiteID: 'abc0abe1b58571f91f6d',
  TrackingID: 'UA-66374966-12',
  Sentry: 'https://faefac7a8b3341edb43cf886cee00ac3@sentry.instacarro.com/21',
  AmplitudeApiKey: '5e7e14a97c70b3b84cac1a5c69fc61b5',
  ConfigCatSDKKey: 'ryjcCKO7c0iCF_n_oynJtQ/co_9FunSK0OcKvolO4VEfA',
  baseURLs: {
    root: 'https://api.instacarro.com',
    authentication: 'https://api.instacarro.com/accounts',
    newAuthentication: 'https://apigateway.instacarro.com/api/evaluation_account/v1/user',
    buyers: 'https://api.instacarro.com/buyers/v2',
    dealers: 'https://api.instacarro.com/dealers/v3',
    sales: 'https://api.instacarro.com/buyers/v2',
    buyersV3: 'https://api.instacarro.com/buyers/v3',
    accounts: 'https://api.instacarro.com/accounts',
    metrics: 'http://api.instacarro.com/managers/v1/metrics',
    internals: 'https://api.instacarro.com/internals',
    ninja_dashboard: 'https://api.instacarro.com/ninja-dashboard-records/dashboard',
    mechanics: 'https://api.instacarro.com/mechanics',
    logistics: 'https://api.instacarro.com/logistics',
    icApiDealers: 'https://api.instacarro.com/ic-api-dealers/v1/dealers',
    baseIcApiDealers: 'https://api.instacarro.com/ic-api-dealers',
    auQueries: 'https://api.instacarro.com/au_queries/v1',
    autobid: 'https://api.instacarro.com/au_managements',
    preferences: 'https://apigateway.instacarro.com/notification_api/order-cars',
    fincredit: 'https://api.instacarro.com/fincredit_simulator_api/api',
    generateDoc: 'https://api.instacarro.com/v1/pipelines/report/dealer/docs',
    calculator: 'https://api.instacarro.com/preferences-calculator',
  },
  externalApps: {
    c2cAdmin: 'https://ec2c-backoffice.instacarro.com/admin/login',
    c2c: 'https://seminovos.instacarro.com',
    newOffers: 'https://app.instacarro.com',
  },
  MixpanelToke: '20bc00aeb623fdab4a2633bd1e85d09c',
  Debug: false,
  IndiqueLin: 'https://cupom.instacarro.com/lojistas',
  GA_Dimentions: {
    dealership_name: 'dimension3',
    auction_id: 'dimension5',
    dealership_id: 'dimension6',
    bid_amount: 'dimension7',
    bid_type: 'dimension8',
    dealership_email: 'dimension9',
    selectedCategory: 'dimension10',
    carResults: 'dimension11',
    interactionType: 'dimension12',
  },
  DOMAIN_APP: '.leilao.instacarro.com',
  FINCREDIT_URL: 'https://leilao.instacarro.com/fincredit/simule',
  UPCOMING_DISPUTES_IFRAME_BASE_URL: 'https://proximo-carro-alerta.lovable.app/',
  UPCOMING_DISPUTES_VEHICLES_URL:
    'https://camxqukqmiqccjlxjhjb.supabase.co/functions/v1/fetch-vehicles',
  // Configurações para cadastro de lojistas
  NEW_URL_API_INSTACARRO: 'https://api.instacarro.com', // TODO: Atualizar com URL correta
  NEW_URL_API_INSTACARRO_API_KEY: 'YOUR_API_KEY_HERE', // TODO: Adicionar chave de API correta
  OneSignalSDK: 'https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js',
  OneSignalAppID: '4fa5fda8-0a99-4a59-a2f6-818be8e2efa0',
};
